import "../../../../assets/presentation/components/controls/text-input/text-input-helper-text-qRLdpDTe.css";
/* empty css                       */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-helper-text.tsx
var TextInputHelperText = ({ className, children, testId }) => /* @__PURE__ */ jsx("p", {
	className: classNames(className, "text-input-helper-text"),
	"data-testid": testId,
	children
});
//#endregion
export { TextInputHelperText };

//# sourceMappingURL=text-input-helper-text2.js.map